export default "__VITE_ASSET__GH352FgG__"